// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__s6Csw","content":"ErrorPage_content__RW0jb","title":"ErrorPage_title__nBYP2","body":"ErrorPage_body__1pHt8","gif":"ErrorPage_gif__eWHZG"};